import { render, staticRenderFns } from "./FlowerIcon2.vue?vue&type=template&id=6ed37636&"
import script from "./FlowerIcon2.vue?vue&type=script&lang=js&"
export * from "./FlowerIcon2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports